/*
  Paylaşılan metin sadeleştirme (aksan ve büyük harf duyarsız arama).

  Tek kaynak olması önemli: aynı isim iki ayrı sayfada farklı sadeleşirse
  ziyaretçi bir yerde bulduğunu diğerinde bulamaz. Hem Artvee galeri
  aramasında hem de Duvarını Tasarla sanatçı seçicisinde bu işlev kullanılır.

  İki aşama vardır. Önce NFD ile ayrışmayan harfler elle eşlenir (ø, ł, đ,
  ß, æ ve Türkçe ı/İ gibi), sonra kalan aksanlar NFD ile ayrıştırılıp
  birleşen işaretler atılır. Yalnızca ilk aşamayı ya da yalnızca ikincisini
  yapmak eksik kalır; ikisi birlikte gerekir.
*/
(function () {
  var MAP = {
    ı: 'i',
    İ: 'i',
    ø: 'o',
    Ø: 'o',
    ł: 'l',
    Ł: 'l',
    đ: 'd',
    Đ: 'd',
    ð: 'd',
    Ð: 'd',
    þ: 't',
    Þ: 't',
    ß: 'ss',
    æ: 'ae',
    Æ: 'ae',
    œ: 'oe',
    Œ: 'oe',
  };

  function fold(str) {
    return String(str == null ? '' : str)
      .replace(/[ıİøØłŁđĐðÐþÞßæÆœŒ]/g, function (ch) {
        return MAP[ch] || ch;
      })
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  window.AlaText = window.AlaText || {};
  window.AlaText.fold = fold;
})();
